import { Navigate, Outlet } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { SPACES_FLAG } from '@/lib/spaces/flag';
import { useFeatureFlags, useFeatureFlagsSettled } from '@/lib/telemetry';

/**
 * Route element for `/spaces/*` (VER-403). Renders the matched child only while the
 * `shared-spaces` flag is on; sends everyone else to `/` — where the catch-all route
 * sent them before the feature existed.
 *
 * Flags resolve asynchronously and read as `false` until then, so the gate waits for
 * the first resolution before deciding, showing a skeleton meanwhile so the shell is
 * never blank. The wait is bounded by useFeatureFlagsSettled's grace period: when
 * telemetry is unavailable, blocked by consent, or slower than the grace, the gate
 * fails CLOSED and redirects — the same default-off stance as every other flag-gated
 * surface. The person can navigate back once the flag has loaded; a gate that waited
 * without bound would strand them on an empty page whenever telemetry is off.
 */
export function SpacesRouteGate() {
  const enabled = useFeatureFlags(SPACES_FLAG);
  const settled = useFeatureFlagsSettled();

  if (enabled) return <Outlet />;
  if (!settled) return <Skeleton role="status" aria-label="Carregando espaços" aria-busy="true" data-testid="spaces-gate-loading" className="h-48 w-full rounded-xl" />;
  return <Navigate to="/" replace />;
}
